import { defineMessages } from 'react-intl';

/* eslint-disable max-len */

export default defineMessages({
  piace: {
    id: 'piace',
    description: 'Like this company',
    defaultMessage: ' tykkää tästä yrityksestä',
  },
  piaceFirst: {
    id: 'piaceFirst',
    description: 'First to like this company',
    defaultMessage: 'Tykkää tästä yrityksestä!',
  },
  piaceShort: {
    id: 'piaceShort',
    description: 'Like this',
    defaultMessage: ' tykkää tästä',
  },
  piaceFirstShort: {
    id: 'piaceFirstShort',
    description: 'First to like this',
    defaultMessage: 'Tykkää tästä!',
  },
});
